import {translate} from 'views/module';

const generateFilterOptions = () => {
  const filterOptions = {};

  filterOptions.status = {
    key: 'status',
    label: translate('career.dashboard.JobListings.Filter.Status'),
    rank: 1,
    options: {
      PENDING: {
        label: 'Pending',
        rank: 0,
        key: 'PENDING',
      },
      REJECTED: {
        label: 'Rejected',
        rank: 1,
        key: 'REJECTED',
      },
      ACCEPTED: {
        label: 'Accepted',
        rank: 2,
        key: 'ACCEPTED',
      },
    },
    canBeEmpty: false,
    multiSelect: true,
  };


  return filterOptions;
};

export {
  generateFilterOptions,
};
